// extracted by css-extract-rspack-plugin
export default {"Details":"Tips-module__Details__JdQG6Cc","OpenLastItem":"Tips-module__OpenLastItem__XrA_50T"};